import ScrollVelocity from '../blocks/TextAnimations/ScrollVelocity/ScrollVelocity'

const ScrollText = () => {
  return (
    <div className="pt-24">
        <ScrollVelocity texts={['HTML CSS PHP JS ', 'Tailwind GSAP NextJS Laravel ThreeJS React']} velocity={50} className="text-white-50"/>
    </div>
  );
};

export default ScrollText;